<template>
  <div class="reportDetails">
    <div class="titleAndCollect">
      <div class="title">
        {{ params.reportName }}
      </div>
      <div v-if="config.headers.token" class="collect" :class="{ hasCollect: params.hasCollect }" @click="toCollect(params.hasCollect)">
        收藏
      </div>
    </div>
    <div class="tags">
      <div class="tag gray" v-if="params.brand">{{ params.brand }}</div>
      <div class="tag" v-if="params.crisis">{{ params.crisis }}</div>
    </div>
    <div class="time">
      {{ params.startTime }}
    </div>
    <div class="content">
      <iframe style="width:100%;height:100%;"
        :src="`${origin}/static/js/pdfjsNew/web/viewer.html?file=${encodeURIComponent(baseUrl + 'mobile/report/' + this.id + '/preview')}&token=${config.headers.token}`"></iframe>
      <!-- <iframe style="width:100%;height:100%;"
            src="http://192.168.0.240:8081/static/js/pdfjsNew/web/viewer.html?file=http://192.168.0.240:8081/static/js/pdfjsNew/web/compressed.tracemonkey-pldi-09.pdf"></iframe> -->
    </div>

    <div class="button-fixed">
      <!-- <div class="button-style blue" @click="viewSample">查看样例</div> -->
      <!-- <div class="button-style orange" @click="contact">联系客服购买</div> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'AppIndex',
  data () {
    return {
      // origin:'https://crisis.zhiweidata.com/',
      // origin:'http://192.168.0.240:8081',
      id: -1,
      baseUrl: window.location.host.search(/(localhost|\d+\.\d+\.\d+\.\d+)/g) !== -1 ? '/interface/' : '/app/',
      config: { headers: { token: '' } },
      params: {
        reportName: '',
        startTime: '',
        brand: '',
        crisis: '',
        hasCollect: false
      }
    }
  },
  computed: {
    origin () {
      return location.origin
    }
  },
  watch: {
    '$route': { // $route可以用引号，也可以不用引号  监听的对象
      handler (to, from) {
        // console.log('路由变化了')
        // console.log('当前页面路由：', to)
        // console.log('上一个路由：', from)
        const { query } = to
        this.config.headers.token = query.token
        // console.log('这是token', query.token)
        this.id = query.id
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true // 第一次初始化渲染就可以监听到
    }
  },
  created () {
    // 引入微信小程序的api
    const oScript = document.createElement('script')
    oScript.type = 'text/javascript'
    oScript.src = 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js'
    document.body.appendChild(oScript)
    document.title = '危机汇'
  },
  mounted () {
    this.getDetails()
  },
  methods: {
    toWxLogin () {
      // 跳转微信小程序页面
      // eslint-disable-next-line no-undef
      wx.miniProgram.switchTab({
        url: '/pages/user/index'
      })
    },
    getDetails () {
      axios.get(`${this.baseUrl}mobile/report/${this.id}/detail`, this.config).then(res => {
        if (res.success) {
          const { data } = res
          this.params.reportName = data.reportName
          this.params.startTime = moment(data.startTime).format('YYYY-MM-DD')
          this.params.brand = data.priBrands.concat(data.secBrands).join(',')
          this.params.crisis = data.priCrisisTags.concat(data.secCrisisTags).join(' | ')
          this.params.hasCollect = data.hasCollect
        }
      })
    },
    async toCollect (collected) {
      let res = null
      if (collected) {
        res = await axios.delete(`${this.baseUrl}collects/report/${this.id}`, this.config)
      } else {
        res = await axios.post(`${this.baseUrl}collects/report/${this.id}`, {}, this.config)
      }
      if (res.success) {
        this.getDetails()
      }
    },
    viewSample () { },
    contact () { }
  }
}
</script>

<style lang="scss" scoped>
.reportDetails {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 10px;

  .titleAndCollect {
    display: flex;
    align-items: center;

    .title {
      flex: 1;
      width: 0;
      font-size: 18px;
      color: "#353535";
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: bold;
    }

    .collect {
      width: 55px;
      height: 23px;
      line-height: 23px;
      border-radius: 12px;
      border: solid 1px #025fea;
      font-size: 12px;
      color: #025fea;
      text-align: center;

      &.hasCollect {
        background-color: #025fea;
        color: #fff;
      }
    }
  }

  .tags {
    margin-top: 13px;
    display: flex;
    font-size: 10px;

    .tag {
      padding: 4px 6px;
      border-radius: 2px;
      border: solid 1px #dddddd;
      color: #999999;
      margin-right: 7px;
    }

    .gray {
      background-color: #a1a3b6;
      border-radius: 2px;
      color: #ffffff;
    }
  }

  .time {
    margin: 10px 0;
    font-size: 12px;
    color: #999999;
  }

  .content {
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    .report-image {
      width: 100%;
    }
  }

  .button-fixed {
    position: fixed;
    bottom: 27px;
    left: 50%;
    transform: translateX(-50%);

    .button-style {
      width: 130px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      box-shadow: 1px 2px 2px 0px rgba(69, 81, 194, 0.4);
      border-radius: 20px;
      font-size: 15px;
      color: #ffffff;
    }

    .blue {
      background-image: linear-gradient(-55deg,
          #1e73f1 0%,
          #025fea 100%);
    }

    .orange {
      background-image: linear-gradient(-28deg,
          #ed7e53 0%,
          #f39558 100%);
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/index/WeixinReport/WeixinReport.vue